import React, { useEffect } from 'react';

import Header from '../components/Header';
import ProductsHub from '../components/ProductsHub';
import Footer from '../components/Footer';
import PageBanner from '../components/PageBanner';
import Seo, { breadcrumbSchema, SITE_URL } from '../components/Seo';
import { SITE_KEYWORDS } from '../config/seoKeywords';
import { PAGE_BANNER_IMAGES } from '../data/homeData';

import '../Home.css';
import '../PageBanner.css';

function ProductsPage() {
  const description = 'Browse Swarvinn Foods wholesale Indian rice, spices, pulses, millets, flours, oils and traditional groceries supplied from Tamil Nadu to UK importers and distributors.';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page products-hub-page">
      <Seo
        title="Wholesale Indian Food Products for UK Import"
        description={description}
        path="/products"
        keywords={SITE_KEYWORDS}
        schema={[
          {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'Wholesale Indian Food Products for UK Import',
            url: `${SITE_URL}/products`,
            description,
            inLanguage: 'en-GB',
          },
          breadcrumbSchema([
            { name: 'Home', path: '/' },
            { name: 'Products', path: '/products' },
          ]),
        ]}
      />
      <Header />
      <main className="main products-page-main">
        <PageBanner
          image={PAGE_BANNER_IMAGES.products}
          eyebrow="UK Wholesale Catalogue"
          title="Indian groceries, export-ready for the UK"
          lead="Browse our full export range — rice, spices, pulses, millets, flours, oils, and traditional staples sourced in Tamil Nadu and supplied to UK wholesalers, cash & carry, and food distributors."
          breadcrumbs={[{ label: 'Products' }]}
        />
        <ProductsHub />
      </main>
      <Footer />
    </div>
  );
}

export default ProductsPage;
